import { Button } from '@montel/montelpro-shared-components-v2';
import { RequestStatus } from '@montel/montelpro-shared-components/enums';
import { SUBSCRIPTIONS_API_ROUTE } from 'apiRoutes';
import { ButtonContainer } from 'components/common/Product/Cells/styles';
import { AdminRole } from 'domain/account/enums/AdminRole';
import {
	Subscription,
	SubscriptionType,
} from 'domain/subscription/interfaces/Subscription';
import useAuthRoles from 'hooks/useAuthRoles';
import useSubmit, { POST } from 'hooks/useSubmit';
import { FunctionComponent } from 'react';

interface UnassignSeatActionCellProps {
	subscriberId: string;
	subscription: Subscription;
	onSuccess: (subscriberId: string) => void;
}

export const UnassignSeatActionCell: FunctionComponent<
	UnassignSeatActionCellProps
> = ({ subscriberId, subscription, onSuccess }) => {
	const { adminIsRestrictedToRole: isRestrictedToRole } = useAuthRoles();

	const [unassignSeat, unassignSeatStatus] = useSubmit(
		`${SUBSCRIPTIONS_API_ROUTE}/UnassignSeat`,
		POST,
		{
			messageOnError: 'An error occured, please try again!',
			messageOnSuccess: `User was successfully unassigned`,
			showApiError: true,
		},
	);

	const onUnassignSeat = async (
		subscriberId: string,
		subscriptionId: number,
	) => {
		const result = await unassignSeat({ subscriberId, subscriptionId });

		if (result.success) {
			onSuccess(subscriberId);
		}
	};

	const canUnassignSeat =
		!isRestrictedToRole(AdminRole.SALES) ||
		(isRestrictedToRole(AdminRole.SALES) &&
			(subscription.type == SubscriptionType.Paid ||
				subscription.type == SubscriptionType.Trial));

	return (
		<ButtonContainer>
			<Button
				size="sm"
				text={'Unassign seat'}
				type="button"
				variant={'secondary'}
				isLoading={unassignSeatStatus === RequestStatus.LOADING}
				onClick={(e) => {
					e.stopPropagation();
					onUnassignSeat(subscriberId, subscription.id);
				}}
				isDisabled={!canUnassignSeat}
			/>
		</ButtonContainer>
	);
};
